const TankerTrucks = () => import("Modules/tanker_trucks/views/TankerTrucks");
const TankerTrucksForm = () => import("Modules/tanker_trucks/views/TankerTrucksForm");

export default {
    children: [
        {
            path: "tanker_trucks",
            name: "tanker_trucks",
            component: TankerTrucks,
            meta: {
                requiresAuth: true,
                title: "lang.tanker_trucks",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["tanker_trucks.read"],
            },
        },
        {
            path: "tanker_truck/:id?",
            name: "tanker_truck",
            component: TankerTrucksForm,
            meta: {
                requiresAuth: true,
                title: "lang.tanker_trucks",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["tanker_trucks.read"],
            },
        },
    ],
};
